
document.addEventListener("DOMContentLoaded", function(event) {
    ((doc)=>{
        let myDoc = doc;

        // The desktop profile gallery is an editorial contact sheet.  Its links remain
        // the original server-rendered Fancybox groups, so opening a tile starts at
        // precisely that image without creating a second media collection.
        const profileFancyboxOptions = {
            mainClass: 'profile-stacked-viewer',
            Carousel: {
                infinite: false,
                transition: 'slide',
            },
            Thumbs: false,
        };
        Fancybox.bind('[data-fancybox="gallery"]', profileFancyboxOptions);
        Fancybox.bind('[data-fancybox="galleryDom"]', profileFancyboxOptions);
        Fancybox.bind('[data-fancybox="galleryPremiumPicture"]');
        Fancybox.bind('[data-fancybox="galleryPremiumVideo"]');
        Fancybox.bind('[data-fancybox="intorVideo"]', {
            Carousel: {
            Thumbs: false,
            },
        });

        let splideReview = myDoc.querySelector('.splideReview');
        if(splideReview){
            var reviewSplide = new Splide( splideReview, {
                gap        : 8,
                arrows     : false,
                pagination : false,
                mediaQuery  : 'min',
                destroy: false,
                padding: '1rem',
                focus  : 'center',
                breakpoints: {
                    768: {
                        perPage: 2,
                    },
                    992: {
                        destroy: true,
                    }
                }
            });
            reviewSplide.mount();
        };

        let youmaulike = myDoc.querySelectorAll('.homeStaffSlide');
        if(youmaulike){
            Object.keys(youmaulike).forEach((ele)=>{
                var staffSplide = new Splide( youmaulike[ele], {
                    gap: 4,
                    arrows : false,
                    pagination: false,
                    fixedWidth  : 170,
                    focus  : 'center',
                    mediaQuery: 'min',
                    padding: '1rem',
                    breakpoints: {
                        768: {
                            gap: 4,
                            omitEnd: true,
                            focus : 0,
                            fixedWidth  : 230,
                        },
                        1200: {
                            gap: 4,
                            fixedWidth  : 250,
                        }
                    }
                });
                staffSplide.mount();
            })
        }

        let duoWidth = myDoc.querySelector('.duoWithStaffSlide');
        if(duoWidth){
            var staffSplide = new Splide( duoWidth, {
                gap: 4,
                arrows : false,
                pagination: false,
                mediaQuery: 'min',
                focus  : 'center',
                padding: '1rem',
                classes: {
                    pagination: 'splide__pagination position-relative bottom-0 d-flex justify-content-md-end justify-content-center mt-4 px-0',
                    page      : 'splide__pagination--page border-0 rounded-circle mx-1',
                },
                breakpoints: {
                    576: {
                        fixedWidth  : '370px',
                        focus  : 0,
                    },
                    768: {
                        gap: 4,
                        omitEnd: true,
                    }
                }
            });
            staffSplide.mount();
        }


        function loadVideoSources() {
            // Inject video sources from data-video-src attribute
            const videos = document.querySelectorAll('.profile-video[data-video-src]');
            videos.forEach(video => {
                const videoSrc = video.getAttribute('data-video-src');
                if (videoSrc) {
                    // On phones / data-saver / slow connections, serve a lighter rendition
                    // instead of the full 1080p file (~10MB), which otherwise auto-downloads
                    // and saturates mobile data. SproutVideo exposes /480.mp4, /720.mp4 etc.
                    let resolvedSrc = videoSrc;
                    const conn = navigator.connection || {};
                    const wantsLite = window.innerWidth < 768
                        || conn.saveData === true
                        || (conn.effectiveType && /2g|3g/.test(conn.effectiveType));
                    if (wantsLite) {
                        resolvedSrc = resolvedSrc.replace(/\/1080\.mp4(\?.*)?$/, '/480.mp4$1');
                    }

                    // Create source element
                    const source = document.createElement('source');
                    source.src = resolvedSrc;
                    source.type = 'video/mp4';

                    // Append source to video
                    video.appendChild(source);

                    // Load the video
                    video.load();

                    // Only autoplay if video is in active slide — but defer the actual play()
                    // until after the page has loaded, so the video's first frame can't become
                    // (or fluctuate into) the LCP. Until then the in-flow poster stays the LCP.
                    const videoSlide = video.closest('.swiper-slide');
                    if (videoSlide && videoSlide.classList.contains('swiper-slide-active')) {
                        const startPlayback = () => {
                            video.play().catch(err => {
                                console.log('Autoplay prevented:', err);
                            });
                        };
                        if (document.readyState === 'complete') {
                            setTimeout(startPlayback, 400);
                        } else {
                            window.addEventListener('load', () => setTimeout(startPlayback, 400), { once: true });
                        }
                    }
                }
            });
        }

        function initSwiper() {
            function updateStoryProgress(swiper) {
                const segments = swiper.el.querySelectorAll('.gs-story-progress__segment');
                segments.forEach((segment, index) => {
                    segment.classList.toggle('is-viewed', index < swiper.activeIndex);
                    segment.classList.toggle('is-active', index === swiper.activeIndex);
                });
            }

            // Inject pagination elements into every gallery swiper before init
            document.querySelectorAll('.swipper-gallerySingle').forEach(el => {
                if (!el.querySelector('.gs-gallery-pagination')) {
                    const pag = document.createElement('div');
                    pag.className = 'swiper-pagination gs-gallery-pagination';
                    el.appendChild(pag);
                }

                if (!el.querySelector('.gs-story-progress')) {
                    const progress = document.createElement('div');
                    progress.className = 'gs-story-progress';
                    progress.setAttribute('aria-hidden', 'true');

                    el.querySelectorAll('.swiper-wrapper > .swiper-slide').forEach(() => {
                        const segment = document.createElement('span');
                        segment.className = 'gs-story-progress__segment';
                        progress.appendChild(segment);
                    });

                    el.appendChild(progress);
                }
            });

            const isMobileGallery = window.matchMedia('(max-width: 767.98px)').matches;
            const isDesktopGallery = window.matchMedia('(min-width: 992px)').matches;
            const cardSwiper = new Swiper(".swipper-gallerySingle", {
                lazy: true,
                effect: (isMobileGallery || isDesktopGallery) ? "slide" : "cards",
                slidesPerView: 1,
                spaceBetween: 0,
                speed: isMobileGallery ? 260 : 300,
                grabCursor: true,
                observer: true,
                observeParents: true,
                followFinger: true,
                threshold: isMobileGallery ? 4 : 5,
                touchRatio: isMobileGallery ? 1.15 : 1,
                touchAngle: 60,
                shortSwipes: true,
                longSwipes: true,
                longSwipesRatio: isMobileGallery ? 0.15 : 0.5,
                longSwipesMs: isMobileGallery ? 300 : 300,
                resistanceRatio: isMobileGallery ? 0.65 : 0,
                touchEventsTarget: 'container',
                pagination: {
                    el: '.gs-gallery-pagination',
                    type: 'fraction',
                },
                breakpoints: {
                    768: {
                        spaceBetween: 20
                    },
                    1024: {
                        spaceBetween: 30
                    }
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous card',
                    nextSlideMessage: 'Next card'
                },
                on: {
                    init: function() {
                        if (this.slides.length <= 1) {
                            this.el.classList.add('gallery-single-slide');
                        }
                        updateStoryProgress(this);
                    },
                    touchStart: function() {
                        // Keep the fraction counter, but retire the visual cue once the
                        // visitor has discovered the story-style gallery gesture.
                        this.el.classList.add('gallery-has-swiped');
                    },
                    slideChange: function() {
                        updateStoryProgress(this);

                        // Small delay to ensure slide transition is complete
                        setTimeout(() => {
                            const videos = document.querySelectorAll('.profile-video');
                            const activeSlide = document.querySelector('.swiper-slide-active');

                            videos.forEach(video => {
                                const videoSlide = video.closest('.swiper-slide');

                                if (videoSlide === activeSlide && videoSlide.classList.contains('video-slide')) {
                                    // This is the active video slide - reset state and autoplay
                                    video.dataset.manuallyPaused = 'false';
                                    video.play().catch(err => {
                                        console.log('Autoplay prevented:', err);
                                    });
                                } else {
                                    // Not active - pause and reset state
                                    if (!video.paused) {
                                        console.log('Pausing video in non-active slide');
                                        video.pause();
                                    }
                                    video.dataset.manuallyPaused = 'false';
                                }
                            });
                        }, 100);
                    }
                }
            });

            // Load video sources from data attributes
            loadVideoSources();

            // Initialize video click controls after a short delay to ensure DOM is ready
            setTimeout(() => {
                initVideoClickControls();
            }, 300);

            // Hide bottom overlay on initial load if video is first slide
            // const bottomOverlay = document.querySelector('.image-only-overlay');
            // if (bottomOverlay) {
            //     const firstSlide = document.querySelector('.swiper-slide-active');
            //     if (firstSlide && firstSlide.classList.contains('video-slide')) {
            //         bottomOverlay.classList.add('hide-overlay');
            //     }
            // }

            return cardSwiper;
        }

        function initVideoClickControls() {
            const videoSlides = document.querySelectorAll('.video-slide');

            if (videoSlides.length === 0) return;

            videoSlides.forEach((videoSlide, index) => {
                const video = videoSlide.querySelector('.profile-video');
                const pauseIndicator = videoSlide.querySelector('.video-pause-indicator');

                if (!video) {
                    return;
                }


                // Store manual pause state
                video.dataset.manuallyPaused = 'false';

                // Click handler directly on video element
                video.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (video.paused) {
                        video.play().catch(err => {
                            console.log('Play prevented:', err);
                        });
                        video.dataset.manuallyPaused = 'false';
                        if (pauseIndicator) pauseIndicator.style.display = 'none';
                    } else {
                        video.pause();
                        video.dataset.manuallyPaused = 'true';
                        // Show pause indicator briefly
                        if (pauseIndicator) {
                            pauseIndicator.style.display = 'block';
                            setTimeout(() => {
                                if (video.paused) {
                                    pauseIndicator.style.display = 'none';
                                }
                            }, 800);
                        }
                    }
                });

                // Show pause indicator when video is paused
                video.addEventListener('pause', function() {
                    if (video.dataset.manuallyPaused === 'true' && pauseIndicator) {
                        pauseIndicator.style.display = 'block';
                        setTimeout(() => {
                            pauseIndicator.style.display = 'none';
                        }, 800);
                    }
                });
            });
        }

        const cursor = document.querySelectorAll('.custom-cursor');
        const parent = document.body; // or a specific container

        parent.addEventListener('mousemove', (e) => {
            if (e.target.closest('.swipper-gallerySingle')) {
                cursor.forEach(c => {
                    c.style.display = 'block';
                    c.style.top = `${e.clientY}px`;
                    c.style.left = `${e.clientX}px`;
                });
            } else {
                cursor.forEach(c => c.style.display = 'none');
            }
        });



        let mySwiper = initSwiper();

        function initDesktopMediaViewers(swipers) {
            const desktopQuery = window.matchMedia('(min-width: 992px)');
            if (!desktopQuery.matches) return;

            const gallerySwipers = Array.isArray(swipers) ? swipers : [swipers];

            gallerySwipers.forEach(swiper => {
                if (!swiper || !swiper.el) return;

                const gallery = swiper.el;
                const slides = Array.from(gallery.querySelectorAll('.swiper-wrapper > .swiper-slide'));
                if (!slides.length || gallery.closest('.desktop-profile-media-shell')) return;

                const shell = document.createElement('div');
                shell.className = 'desktop-profile-media-shell';
                gallery.parentNode.insertBefore(shell, gallery);
                shell.appendChild(gallery);
                gallery.classList.add('desktop-profile-media-viewer');

                const rail = document.createElement('div');
                rail.className = 'desktop-profile-media-rail';
                rail.setAttribute('role', 'tablist');
                rail.setAttribute('aria-label', 'Profile media');

                slides.forEach((slide, index) => {
                    const button = document.createElement('button');
                    const image = slide.querySelector('img');
                    const isVideo = slide.classList.contains('video-slide');
                    button.type = 'button';
                    button.className = 'desktop-profile-media-thumb';
                    button.setAttribute('role', 'tab');
                    button.setAttribute('aria-label', `${isVideo ? 'Play video' : 'View photo'} ${index + 1}`);
                    button.setAttribute('aria-selected', index === swiper.activeIndex ? 'true' : 'false');

                    if (image) {
                        const thumb = document.createElement('img');
                        thumb.src = image.currentSrc || image.src;
                        thumb.alt = '';
                        thumb.loading = index < 6 ? 'eager' : 'lazy';
                        button.appendChild(thumb);
                    }

                    if (isVideo) {
                        const play = document.createElement('span');
                        play.className = 'desktop-profile-media-thumb__play';
                        play.setAttribute('aria-hidden', 'true');
                        play.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M4 2.5L13 8L4 13.5V2.5Z" fill="currentColor"/></svg>';
                        button.appendChild(play);
                    }

                    button.addEventListener('click', () => swiper.slideTo(index));
                    rail.appendChild(button);
                });

                const navigation = document.createElement('div');
                navigation.className = 'desktop-profile-media-navigation';
                navigation.innerHTML = `
                    <button type="button" class="desktop-profile-media-nav desktop-profile-media-nav--prev" aria-label="Previous media">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12.5 4L6.5 10L12.5 16" stroke="currentColor" stroke-width="1.8"/></svg>
                    </button>
                    <button type="button" class="desktop-profile-media-nav desktop-profile-media-nav--next" aria-label="Next media">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 4L13.5 10L7.5 16" stroke="currentColor" stroke-width="1.8"/></svg>
                    </button>`;

                shell.prepend(rail);
                shell.appendChild(navigation);

                const previous = navigation.querySelector('.desktop-profile-media-nav--prev');
                const next = navigation.querySelector('.desktop-profile-media-nav--next');
                previous.addEventListener('click', () => swiper.slidePrev());
                next.addEventListener('click', () => swiper.slideNext());

                const syncViewerControls = () => {
                    rail.querySelectorAll('.desktop-profile-media-thumb').forEach((button, index) => {
                        const active = index === swiper.activeIndex;
                        button.classList.toggle('is-active', active);
                        button.setAttribute('aria-selected', active ? 'true' : 'false');
                        if (active) button.scrollIntoView({ block: 'nearest' });
                    });
                    previous.disabled = swiper.isBeginning;
                    next.disabled = swiper.isEnd;
                };

                swiper.on('slideChange', syncViewerControls);
                syncViewerControls();
                swiper.update();
            });
        }

        initDesktopMediaViewers(mySwiper);

        // Swiper needs a clean lifecycle when crossing between the desktop media
        // viewer and the untouched tablet/mobile card presentation.
        const desktopViewerQuery = window.matchMedia('(min-width: 992px)');
        desktopViewerQuery.addEventListener('change', () => window.location.reload());
        if(mySwiper){
            const updateSwipers = () => {
                const swipers = Array.isArray(mySwiper) ? mySwiper : [mySwiper];
                swipers.forEach(swiper => {
                    if (swiper && typeof swiper.update === 'function') {
                        swiper.update();
                    }
                });
            };
            const tabEls = document.querySelectorAll('button[data-bs-toggle="tab"]');
            tabEls.forEach(tab => {
                tab.addEventListener('shown.bs.tab', function() {
                    updateSwipers();
                    setTimeout(updateSwipers, 100);
                });
            });
        }

        function initMobileProfileTabs() {
            const tabList = document.querySelector('.profile-mobile-tabs');
            if (!tabList) return;

            const tabs = Array.from(tabList.querySelectorAll('[data-profile-tab-target]'));
            const panels = Array.from(document.querySelectorAll('[data-profile-tab-panel]'));
            if (!tabs.length || !panels.length) return;
            const mobileQuery = window.matchMedia('(max-width: 767.98px)');
            const panelAnchors = new Map();

            panels.forEach(panel => {
                const anchor = document.createComment(`profile-panel-${panel.dataset.profileTabPanel}`);
                panel.parentNode.insertBefore(anchor, panel);
                panelAnchors.set(panel, anchor);
            });

            const restorePanel = panel => {
                const anchor = panelAnchors.get(panel);
                if (anchor && anchor.parentNode) {
                    anchor.parentNode.insertBefore(panel, anchor.nextSibling);
                }
            };

            const activateTab = (name, moveFocus = false, focusName = name) => {
                tabs.forEach(tab => {
                    const isActive = tab.dataset.profileTabTarget === name;
                    const keepsFocus = tab.dataset.profileTabTarget === focusName;
                    tab.classList.toggle('is-active', isActive);
                    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
                    tab.setAttribute('tabindex', keepsFocus ? '0' : '-1');
                    if (keepsFocus && moveFocus) tab.focus();
                });

                panels.forEach(panel => {
                    const isActive = panel.dataset.profileTabPanel === name;
                    panel.classList.toggle('is-mobile-tab-active', isActive);
                    if (mobileQuery.matches && isActive) {
                        const activeTab = tabs.find(tab => tab.dataset.profileTabTarget === name);
                        if (activeTab) activeTab.insertAdjacentElement('afterend', panel);
                        panel.querySelector(':scope > .accordion-collapse')?.classList.add('show');
                    } else {
                        restorePanel(panel);
                    }
                });
            };

            tabs.forEach((tab, index) => {
                tab.addEventListener('click', () => {
                    const target = tab.dataset.profileTabTarget;
                    const isOpen = tab.classList.contains('is-active');
                    activateTab(isOpen ? null : target, false, target);
                });
                tab.addEventListener('keydown', event => {
                    if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;
                    event.preventDefault();
                    const direction = event.key === 'ArrowDown' ? 1 : -1;
                    const nextIndex = (index + direction + tabs.length) % tabs.length;
                    activateTab(tabs[nextIndex].dataset.profileTabTarget, true);
                });
            });

            activateTab(tabs[0].dataset.profileTabTarget);

            mobileQuery.addEventListener('change', () => {
                if (mobileQuery.matches) {
                    const activeTab = tabs.find(tab => tab.classList.contains('is-active')) || tabs[0];
                    activateTab(activeTab.dataset.profileTabTarget);
                } else {
                    panels.forEach(restorePanel);
                }
            });
        }

        initMobileProfileTabs();

        function initDesktopProfileTabs() {
            const tabList = document.querySelector('.profile-desktop-tabs');
            if (!tabList) return;

            const tabs = Array.from(tabList.querySelectorAll('[data-profile-desktop-tab]'));
            const panels = Array.from(document.querySelectorAll('[data-profile-desktop-panel]'));
            if (!tabs.length || !panels.length) return;

            const activateTab = (name, moveFocus = false) => {
                tabs.forEach(tab => {
                    const isActive = tab.dataset.profileDesktopTab === name;
                    tab.classList.toggle('is-active', isActive);
                    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tab.setAttribute('tabindex', isActive ? '0' : '-1');
                    if (isActive && moveFocus) tab.focus();
                });

                panels.forEach(panel => {
                    const isActive = panel.dataset.profileDesktopPanel === name;
                    panel.classList.toggle('is-desktop-tab-active', isActive);
                    if (isActive) {
                        panel.querySelector(':scope > .accordion-collapse')?.classList.add('show');
                    }
                });
            };

            tabs.forEach((tab, index) => {
                tab.addEventListener('click', () => activateTab(tab.dataset.profileDesktopTab));
                tab.addEventListener('keydown', event => {
                    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
                    event.preventDefault();
                    const direction = event.key === 'ArrowRight' ? 1 : -1;
                    const nextIndex = (index + direction + tabs.length) % tabs.length;
                    activateTab(tabs[nextIndex].dataset.profileDesktopTab, true);
                });
            });

            activateTab(tabs[0].dataset.profileDesktopTab);
        }

        initDesktopProfileTabs();

        function initGalleryModeToggle() {
            const toggle = document.querySelector('.gallery-mode-toggle');
            if (!toggle) return;

            const mainTab = document.querySelector(toggle.dataset.mainTab);
            const domTab = document.querySelector(toggle.dataset.domTab);
            if (!mainTab || !domTab || typeof bootstrap === 'undefined') return;

            const updateToggle = () => {
                const isDominatrix = domTab.classList.contains('active');
                toggle.setAttribute('aria-pressed', isDominatrix ? 'true' : 'false');
                const label = toggle.querySelector('.gallery-mode-toggle__label');
                if (label) {
                    label.textContent = isDominatrix ? 'Main Gallery' : 'Dominatrix Gallery';
                }
            };

            toggle.addEventListener('click', () => {
                const target = domTab.classList.contains('active') ? mainTab : domTab;
                bootstrap.Tab.getOrCreateInstance(target).show();
            });

            mainTab.addEventListener('shown.bs.tab', updateToggle);
            domTab.addEventListener('shown.bs.tab', updateToggle);
            updateToggle();
        }

        initGalleryModeToggle();


        ((selector) => {
        const voiceNote = myDoc.querySelectorAll(selector);
            if(voiceNote){
                Object.keys(voiceNote).forEach((key) => {
                const playBtn = voiceNote[key].querySelector('.btn-playpause');
                const soundWave = playBtn.querySelector('.fa-waveform');
                const micIcon = playBtn.querySelector('.vn-mic');
                const voice = voiceNote[key].querySelector('audio');
                playBtn.addEventListener('click', function() {
                    if (voice.paused) {
                    voice.play();
                        soundWave.classList.remove('d-none');
                        micIcon && micIcon.classList.add('d-none');
                    }else{
                    voice.pause();
                        soundWave.classList.add('d-none');
                        micIcon && micIcon.classList.remove('d-none');
                    }
                });
                voice.addEventListener("ended", function() {
                    soundWave.classList.add('d-none');
                    micIcon && micIcon.classList.remove('d-none');
                });
                });
                const stopOther = (e) => {
                    Object.keys(voiceNote).forEach((key) => {
                        if(voiceNote[key].querySelector('audio') != e.target){
                            voiceNote[key].querySelector('audio').pause();
                            voiceNote[key].querySelector('.btn-playpause .fa-waveform').classList.add('d-none');
                            const otherMic = voiceNote[key].querySelector('.btn-playpause .vn-mic');
                            otherMic && otherMic.classList.remove('d-none');
                        }
                    });
                }
                Object.keys(voiceNote).forEach((key) => {
                    voiceNote[key].querySelector('audio').addEventListener('play', stopOther);
                });
            }
        })('.gs-voicenote');


        let videos =  myDoc.querySelectorAll('.textareaVideo');
        if(videos){
            let videoContainer = myDoc.querySelector('.gallery-single-video .row'),
            videoTabBtn = myDoc.querySelector('#videos-tab'),
            VideoHtml='';
            videoContainer?videoContainer.innerHTML = '':null;
            Object.keys(videos).forEach(i=>{
                //console.log(videos[i].getAttribute('value'));
                VideoHtml += `
                <div class="col-md-6 mb-3">
                    <div class="media-holder video">
                        ${videos[i].getAttribute('value')}
                    </div>
                </div>
                `
            });
            if(VideoHtml && videoContainer !='') {
                videoTabBtn.addEventListener('click', ()=>{
                    videoContainer.innerHTML=VideoHtml;
                })
            }
        };
    })(document);
})


